import { Typography } from 'antd';
import clx from 'classnames';
import React from 'react';
import { down } from 'styled-breakpoints';
import { useBreakpoint } from 'styled-breakpoints/react-styled';
import styled from 'styled-components';
const { Title } = Typography;

const AdminTitleRowWrapper = styled.div`
  max-width: 100%;
  display: flex;
  align-items: center;
  padding-top: 5px;
  padding-bottom: 5px;
  transition: all 0.3s;
  &.affixed {
    padding-top: 0;
    padding-bottom: 0;
  }
`;
const PrefixWrapper = styled.div`
  flex: 0 0 auto;
  min-width: 0;
  padding-top: 3px;
  align-self: flex-start;
`;
const TitleWrapper = styled.div`
  flex: 1 1 0;
  min-width: 0;
  padding-right: 16px;
  .ant-typography {
    margin-bottom: 0;
    font-size: 1.5rem;
  }
`;
const TitlePrefixContainer = styled.div`
  flex: 1 1 0;
  min-width: 0;
  display: flex;
`;
const ActionsWrapper = styled.div`
  flex: 0 0 auto;
  min-width: 0;
`;

export interface AdminTitleRowProps {
  title: string;
  prefix?: React.ReactNode;
  actions?: React.ReactNode;
  affixed?: boolean;
  hasBreadcrumb?: boolean;
}

export function AdminTitleRow(props: AdminTitleRowProps) {
  const isMobile = useBreakpoint(down('md'));
  const { title, prefix, actions, affixed, hasBreadcrumb } = props;

  return (
    <AdminTitleRowWrapper
      className={clx({ affixed, 'has-breadcrumb': hasBreadcrumb })}
    >
      <TitlePrefixContainer>
        {prefix && <PrefixWrapper>{prefix}</PrefixWrapper>}
        <TitleWrapper>
          <Title ellipsis={affixed}>{title}</Title>
        </TitleWrapper>
      </TitlePrefixContainer>
      {actions && <ActionsWrapper>{actions}</ActionsWrapper>}
    </AdminTitleRowWrapper>
  );
}
